var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA0lBMVEX///+rqwD+7wD+7wDA wADt7QD98AD97gABAQD97wD+8AD+8AD+7wD+8AD+8AD97wD+7wD+8AD98AD+7wD88AD+8AD77gD7 7wD+8AD87QD+8AD+8AD+8AD77wD+8AD16wD27QD27AD67gDm5gD67wD87QD+8AD+8AD87gD97gD+ 8AD+8AD+8AD+8AD+8AD+7wD98AD98AD+8AD06QD+8AD68AD+8ADz5gD+8AD37gD27QD97wD+8ADs 7AD88AD+8AD56wD56wD+8AD+8AD/8AD///+V7sg5AAAARHRSTlMAA5qcBA51dwFr7+mr6vFtifJh i0H5Ozz6RrqVtz/2GRsaLAovRPX0R2fU05SoqcxzdMsX/TL8FOcdHG7oDUOnJiWzsYC5PD4AAAAB YktHRACIBR1IAAAACXBIWXMAAEzlAABM5QF1zvCVAAAAB3RJTUUH5goGBC0MTYerWgAAAK9JREFU GNNdkNcSgkAMRUFBLFhAUBRRFLF3RAEFW/7/m2Rgi+59yZkz2U0mHIfCF4oCx0QsAUjinypXqjVZ rjeav7KlqOlbQVXa1Gl6J4eu0SOyb2IyB2SwbmG0hjyiEdhY2jBGNAEHSwemiNwZnTlfIFiuqFzj VTdbKnd4kf2ByuMpr97Zp9K/XLMqBWFEEga3rPEOfwm8VMYRk5j8lTzSJMyRnwaA/mJP774/GuYv URIYSq0pH2MAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTAtMDZUMDQ6NDU6MTIrMDA6MDDZRj43 AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEwLTA2VDA0OjQ1OjEyKzAwOjAwqBuGiwAAACh0RVh0 ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMC0wNlQwNDo0NToxMiswMDowMP8Op1QAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9e385954270d1fdcbd9207f1d8d45e34.svg";
export { ForwardRef as ReactComponent };